// TODO: <
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: >

import { useCallback, useMemo, useState } from 'react';
import { useTransactionAdder } from 'store/transactions/hooks';
import useTarotRouter, { useDoUpdate } from './useTarotRouter';
import { ButtonState } from '../components/InteractionButton';

export default function useClaimTowerReward(towerPoolFactoryAddress: Address, pools: Address[], tokens: Address[][]): [ButtonState, () => Promise<void>] {
  const tarotRouter = useTarotRouter();
  const doUpdate = useDoUpdate();
  const addTransaction = useTransactionAdder();
  const [pending, setPending] = useState<boolean>(false);

  const claimsState: ButtonState = useMemo(() => {
    if (pending) return ButtonState.Pending;
    return ButtonState.Ready;
  }, [pending]);

  const claimTowerReward = useCallback(async (): Promise<void> => {
    if (claimsState !== ButtonState.Ready) return;
    setPending(true);
    try {
      await tarotRouter.claimTowerReward(towerPoolFactoryAddress, pools, tokens, (hash: string) => {
        addTransaction({ hash }, { summary: 'Claim Tower reward' });
      });
      doUpdate();
    } finally {
      setPending(false);
    }
  }, [towerPoolFactoryAddress, pools, tokens, addTransaction]);

  return [claimsState, claimTowerReward];
}
